import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-401de4ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_DepartureItem = _resolveComponent("DepartureItem")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass(["departure-list", { 'disabled': _ctx.disabled || _ctx.isLocked }])
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_BaseSpinner, {
          key: 0,
          size: 40
        }))
      : (!_ctx.loading && _ctx.departures.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.departures, (departure) => {
            return (_openBlock(), _createBlock(_component_DepartureItem, {
              key: departure,
              departure: departure,
              direction: _ctx.direction,
              selected: _ctx.departureInput === departure.departureId,
              modelValue: _ctx.departureInput,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.departureInput) = $event))
            }, null, 8, ["departure", "direction", "selected", "modelValue"]))
          }), 128))
        : (_openBlock(), _createElementBlock("li", _hoisted_1, [
            _createVNode(_component_BaseAlert, {
              type: "danger",
              message: _ctx.$t('messages.departures.empty')
            }, null, 8, ["message"])
          ]))
  ], 2))
}